<template>
    <div>
        <el-card class="dashboard-card"
                 :body-style="isShowInit ? null : {padding: 0}"
                 v-loading="isLoading">
            <div slot="header">
                <h3 class="cart-title cart-title--clickable"
                    @click.prevent="isShowInit = !isShowInit">
                    <i class="el-icon-setting"></i>
                    앱 초기 설정
                    <i :class="{'el-icon-arrow-down': !isShowInit, 'el-icon-arrow-up': isShowInit}"></i>
                </h3>
            </div>
            <ul v-show="isShowInit"
                class="init-list">
                <li>
                    <el-button type="primary"
                               plain
                               @click.prevent="updateScript">스크립트 등록
                    </el-button>
                    <span class="init-item-desc">최초 1번 혹은 스크립트에 문제가 발생한 경우 눌러주세요.</span>
                </li>
                <li>
                    <el-button type="primary"
                               plain
                               @click.prevent="createCategory">주문제작용 카테고리 생성
                    </el-button>
                    <span class="init-item-desc">[P-ART] 이름의 주문제작 용 카테고리를 생성합니다. 최초 1번만 실행해주세요.</span>
                </li>
            </ul>
        </el-card>

        <el-card class="dashboard-card">
            <div slot="header">
                <h3 class="cart-title"><i class="el-icon-guide"></i> 사용 가이드</h3>
            </div>
            <!-- @formatter:off -->
            <p class="desc--guide">특정 상품을 커스터마이징 상품으로 지정하여
                <el-tag>구매</el-tag> 버튼 대신
                <el-tag>꾸미기</el-tag> 버튼을 넣을 수 있습니다.
            </p>
            <p class="desc--guide">커스터마이징 상품으로 등록하기 위해서는 <b>상품 수정</b> -> <b>검색어설정</b>에
                <el-tag type="info" effect="dark">PDIY:M2M</el-tag>
                문구를 넣으면 됩니다. (<el-tag type="info" effect="dark">PDIY:상품타입</el-tag>)
            </p>
            <p class="desc--guide">예를 들어:
                <el-tag type="info" effect="plain">검색어1,PDIY:M2M,검색어2</el-tag> ,
                <el-tag type="info" effect="plain">검색어3,PDIY:NASY</el-tag> ,
                <el-tag type="info" effect="plain">PDIY:SHORT,검색어4</el-tag>
            </p>
            <p class="desc--guide">사용자가 꾸미기를 시도하여 만들어진 상품의 가격/옵션/상세설명은 커스터마이징 상품과 동일합니다.</p>
            <img class="desc-img"
                 :src="$S3_PREFIX + 'upload/97bef581-cc7d-4687-a178-d75683d5613c'"
                 alt="검색어 예시"/>
            <p class="desc--guide">사용 가능한 상품 타입은 상단의 [<b>디자인 상품 목록</b>] 메뉴에서 확인할 수 있습니다.</p>
            <!-- @formatter:on -->
        </el-card>
    </div>
</template>

<script>
    import {RepositoryFactory} from '@/repositories/RepositoryFactory';

    const PrintingDiyRepository = RepositoryFactory.get('printingDiy');

    export default {
        name: 'Cafe24AppHome',
        data() {
            return {
                isShowInit: false,
                isLoading: false,
            };
        },
        computed: {
            mall() {
                return this.$store.state.cafe24.mall;
            },
            authToken() {
                return this.$store.state.auth.authToken;
            },
        },
        methods: {
            async updateScript() {
                try {
                    this.isLoading = true;
                    await PrintingDiyRepository.putCafe24UpdateScript(this.mall.mallId, this.mall.shopNo, this.authToken);
                    this.$message.success('스크립트가 등록되었습니다.');
                } catch (e) {
                    this.$message.error(e.message);
                } finally {
                    this.isLoading = false;
                }
            },
            async createCategory() {
                try {
                    this.isLoading = true;
                    await PrintingDiyRepository.postCafe24CreateCategory(this.mall.mallId, this.mall.shopNo, this.authToken);
                    this.$message.success('카테고리가 생성되었습니다.');
                } catch (e) {
                    this.$message.error(e.message);
                } finally {
                    this.isLoading = false;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .init-list {
        list-style: none;

        li {
            padding: 10px 0;

            .init-item-desc {
                padding-left: 10px;
                font-size: 16px;
                color: #666;
            }
        }
    }

    .desc--guide {
        color: #444444;
        font-size: 16px;
        line-height: 42px;
    }

    .desc-img {
        margin: 10px 0;
        border: 1px solid #666;
        width: 100%;
        max-width: 1000px;
    }
</style>